import VeeamImg from "public/disasterRecovery/veeam-img.png";

export const OFFERING_CONSTANTS = {
  title: "Safeguarding your Data ,\n Simplifying Your Recovery",
  text: "Always back up your data!",
  image: VeeamImg,
};
